// @ts-expect-error file not converted to TS yet
import Cookie from 'js-cookie';
import { LOGIN_METADATA_COOKIE_NAME } from '../constants/cookies';
import { getDomain } from './urls';
export const setLoginMetadataCookieEnableAll = () => {
  Cookie.set(LOGIN_METADATA_COOKIE_NAME, JSON.stringify({
    isMobileLogin: true
  }), {
    domain: getDomain()
  });
};
export const getParsedLoginMetadataCookie = () => {
  const loginMetadataCookie = Cookie.get(LOGIN_METADATA_COOKIE_NAME);
  return JSON.parse(loginMetadataCookie.replace(/\\"/g, '"'));
};
export const getReauthCookieValue = () => {
  return Cookie.get('hs_reauth');
};
export const getParsedReauthCookieValue = () => {
  try {
    const reauthCookie = getReauthCookieValue();
    if (reauthCookie) {
      return JSON.parse(atob(reauthCookie));
    }
    return {};
  } catch (_unused) {
    return {};
  }
};